import React from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import './bottom-nav.css';
import configData from "../../ReusableComponents/app-configs";
import { isAdminUser } from "../../../services/commonService";
// import { fetchPermissionList } from "../../../redux/Slices/settings/users/UsersSlice";

const BottomNav = ({ handleClick }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentPath = location.pathname;
  const { permissionList } = useSelector((state) => state.users);
  const isAdmin = isAdminUser();

  const navItems = configData.getNavConfig({
    t,
    permissionList: permissionList?.data || [],
    isAdmin
  });

  const isActive = (path) => {
    if (path === '/' && currentPath === '/') return true;
    if (path !== '/' && currentPath.startsWith(path)) return true;
    return false;
  };

  // const dispatch = useDispatch();
  // const fetchPermissionCall = () => {
  //            dispatch(fetchPermissionList({staff_id: 36}));
  // }

  return (
    <div className="bottomNav" id="menuNavigation">
      {/* <button className="btn btn-primary mx-3" onClick={fetchPermissionCall}>Refresh Permissions</button> */ }
      <ul className="mb-0 d-flex">
        { navItems.map(({ path, label }) => (
          <li
            key={ path }
            className={ `nav-item flex-grow-1 ${ isActive(path) ? 'active' : '' }` }
          >
            <Link
              className="nav-link"
              to={ path }
              onClick={ () => handleClick(path) }
            >
              { label }
            </Link>
          </li>
        )) }
      </ul>
    </div>
  );
};

BottomNav.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default BottomNav;